module.exports = __webpack_public_path__ + "static/media/GoogleSans-Italic.0ecddcde.ttf";